module.exports = __webpack_public_path__ + "static/media/twitter.1cbf33f1.svg";